import React, { useEffect, useRef } from 'react'
import Pagination from '../molecules/Pagination'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducer } from '../../redux/rootReducer'
import { FETCH_OFFERS, SET_CURRENT_PAGE } from '../../redux/paginatedOffersReducer'
import BrowseItem from '../molecules/BrowseItem'
import { useLocation } from 'react-router-dom'

const PaginatedOffersBrowse = (): JSX.Element => {
  const location = useLocation()
  const dispatch = useDispatch()
  const currentPage = useSelector((state: RootReducer) => state.paginatedOffersReducer.currentPage)
  const totalPages = useSelector((state: RootReducer) => state.paginatedOffersReducer.totalPages)
  const totalItems = useSelector((state: RootReducer) => state.paginatedOffersReducer.totalCount)
  const offers = useSelector((state: RootReducer) => state.paginatedOffersReducer.offers)
  const tab = useSelector((state: RootReducer) => state.offersListReducer.tab)
  const filters = useSelector((state: RootReducer) => state.tableToolsReducer.filters[tab])
  const buyNowFiler = useSelector((state: RootReducer) => state.tableToolsReducer.filters[tab].buyNowFiler)
  const browseWrapperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    dispatch(FETCH_OFFERS())
  }, [currentPage, dispatch, filters, buyNowFiler, location])

  useEffect(() => {
    dispatch(SET_CURRENT_PAGE({ currentPage: 1 }))
  }, [filters, buyNowFiler, dispatch])

  const headerHeight = 200
  return (
    <div
      ref={browseWrapperRef}
      style={{ height: `calc(100vh - ${headerHeight}px)` }}
      className="h-full w-full overflow-scroll">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
        {offers.map((offer) => (
          <BrowseItem
            key={offer.id}
            label1={offer.label1}
            label2={offer.label2}
            highestBet={offer.highest_bet}
            photo={offer.photo}
            score={offer.score}
            isLiked={offer.is_liked}
            contractStatus={offer.contract_status}
            offerId={offer.id}
            yourHighestBet={offer.current_dealer_highest_bet}
            buyNowPrice={offer.buy_now_contract?.price}
            buyNowContractId={offer.buy_now_contract?.id}
            zipCode={offer.zip_code}
            countryCode={offer.country_code ?? ''}
          />
        ))}
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalItems}
        onPageChange={(page) => {
          dispatch(SET_CURRENT_PAGE({ currentPage: page }))
          browseWrapperRef.current?.scrollTo({ top: 0, behavior: 'smooth' })
        }}
      />
    </div>
  )
}

export default PaginatedOffersBrowse
